import React from 'react'
import { AppSitesAutocomplete } from '@components'
import { useAppFormHandler } from '@hooks'


export default function SitesSelector() {

	const { sites, onSitesChange } = useAppFormHandler('sites')

	return <AppSitesAutocomplete
		value={sites}
		onChange={e => onSitesChange(e.target.value)}
	/>
}